import styled from "styled-components";
import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";

const Wrap = styled.div`
	position: relative;
	padding-bottom: 40px;
`;

const Header = styled.header`
	display: flex;
	height: 35px;
	padding: 12px 15px;
	border-bottom: 1px solid var(--line-color);
	justify-content: space-between;
	align-items: center;
`;

const ConfirmButton = styled.a`
	display: flex;
	padding: 0 15px;
	color: var(--emp-color);
	font-size: 12px;
	border: 1px solid #bbb;
	border-radius: 20px;
	background-color: #fff;
	align-items: center;
	line-height: 1;
`;

const Logo = styled.a`
	position: relative;
	display: flex;
	width: 85px;
	height: 30px;
	align-items: center;

	img {
		width: 100%;
	}
`;

const LocalmainTitle = styled.h3`
	margin: 40px 0 20px;
	line-height: 1;
	font-size: var(--title-size);
	font-weight: 700;
	color: var(--emp-color);
	text-align: center;
`;

const LocalList = styled.ul`
	position: relative;
	display: flex;
	border-top: 1px solid var(--line-color);
	overflow: hidden;
	flex-flow: wrap;

	li {
		position: relative;
		display: flex;
		min-height: 40px;
		border-bottom: 1px solid var(--line-color);
		justify-content: center;
		align-items: center;
		flex: 0 0 33.33%;

		a {
			display: flex;
			width: 100%;
			height: 100%;
			padding: 5px;
			text-align: center;
			line-height: 1.2;
			box-sizing: border-box;
			justify-content: center;
			align-items: center;
		}

		&:before {
			position: absolute;
			top: 0;
			right: -1px;
			display: block;
			width: 1px;
			height: 220%;
			background: var(--line-color);
			content: "";
		}
	}
	&:after {
		position: absolute;
		bottom: 0;
		left: 0;
		display: block;
		width: 100%;
		height: 1px;
		background: var(--line-color);
		content: "";
	}
`;

const ProductList = styled.ul`
	padding: 0 15px;
`;

const Thumbnail = styled.div`
	img {
		width: 100%;
		max-width: 100%;
		max-height: 210px;
	}
`;

const InfoBox = styled.div`
	display: block;
	padding: 15px 0 20px;

	h4 {
		font-size: var(--default-size);
		font-weight: bold;
		color: var(--emp-color);
		line-height: 1.6;
	}
`;

const Pirice = styled.span`
	display: block;
	font-size: var(--default-size);
	color: var(--red-color);
	text-align: right;

	em {
		font-size: var(--medium-size);
		font-weight: bold;
	}
`;

const CategoryList = styled.ul`
	position: relative;
	display: flex;
	border-top: 1px solid var(--line-color);
	border-left: 1px solid var(--line-color);
	border-right: 1px solid var(--line-color);
	overflow: hidden;
	flex-flow: wrap;

	&:after {
		position: absolute;
		bottom: 0;
		left: 0;
		display: block;
		width: 100%;
		height: 1px;
		background: var(--line-color);
		content: "";
	}
`;

const CategoryListItem = styled.li<{active?: boolean}>`
	position: relative;
	display: flex;
	min-height: 40px;
	border-bottom: 1px solid var(--line-color);
	justify-content: center;
	align-items: center;
	flex: 0 0 50%;

	${props =>
		props.active
			? `    background-color: #ffc72c;
    				color: #222;
				`
			: ""}

	a {
		display: flex;
		width: 100%;
		height: 100%;
		padding: 5px;
		text-align: center;
		line-height: 1.2;
		box-sizing: border-box;
		justify-content: center;
		align-items: center;
	}

	&:before {
		position: absolute;
		top: 0;
		right: -1px;
		display: block;
		width: 1px;
		height: 220%;
		background: var(--line-color);
		content: "";
	}
`;

const Category = styled.section`
	margin: 30px 15px;
`;

const FilterWrap = styled.div`
	border-top: 1px solid var(--line-color);
`;
const SelectBox = styled.div`
	position: relative;
	display: flex;
	cursor: pointer;
	-webkit-box-pack: justify;
	justify-content: space-between;
	border-left: 1px solid var(--line-color);

	select {
		width: 130px;
		height: 100%;
		padding: 0px 15px 0px 10px;
		border: none;
		letter-spacing: -0.1em;
		background-color: transparent;
		color: var(--emp-color);
	}

	&:after {
		position: absolute;
		right: 15px;
		top: 18px;
		width: 7px;
		height: 7px;
		border-top: 2px solid #1d1d1d;
		border-right: 2px solid #1d1d1d;
		background-color: transparent;
		transform: rotate(135deg);
		content: "";
	}
`;

const Price = styled.span`
	position: relative;
	display: block;
	text-align: right;
	font-size: 12px;
	line-height: 1;
	color: var(--red-color);
	em {
		font-size: 21px;
		font-weight: bold;
	}
`;

const ImageWrap = styled.div`
	width: 100%;
	height: 200px;

	img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
	}
`;

const BtnBlock = styled.div`
	display: flex;
	margin-top: 20px;
	padding: 0 15px;
	gap: 10px;
`;

const OptionBox = styled.div`
	display: flex;
	padding: 27px 15px;
	border-top: 1px solid var(--line-color);
	background-color: #fbf9e1;
	font-size: 17px;
	align-items: center;
	justify-content: center;
	gap: 10px;

	p {
		color: var(--emp-color);
	}
`;

const ScheduleIconList = styled.ul<{totalItems: number}>`
	display: grid;
	padding: 20px 15px;
	background-color: var(--disabled-color);
	border-top: 1px solid var(--line-color);
	grid-template-columns: ${props => (props.totalItems <= 8 ? "repeat(4, 1fr)" : "repeat(5, 1fr)")};
	gap: 10px 8px;

	li {
		display: flex;
		font-size: var(--basic-size);
		color: var(--emp-color);
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	span {
		letter-spacing: -0.05em;
	}
`;

const ScheduleIcon = styled.span<{icon: string}>`
	display: block;
	width: 40px;
	height: 40px;
	margin-bottom: 10px;
	background: url(${SpriteImage});
	background-size: 300px 300px;
	background-color: #fff;
	border-radius: 50%;

	${props =>
		props.icon === "schedule" &&
		`
		background-position: 0 -13.6rem;
	`}
	${props =>
		props.icon === "air" &&
		`
		background-position: -2.6rem -13.6rem;
    `}
	${props =>
		props.icon === "air-premium" &&
		`
		background-position: -13.4rem -13.6rem;
	`}
    ${props =>
		props.icon === "decide" &&
		`
		background-position: -5.4rem -13.6rem;
    `}
    ${props =>
		props.icon === "guide" &&
		`
		background-position: -8rem -13.6rem;
    `}
    ${props =>
		props.icon === "expenses" &&
		`
		background-position: -10.7rem -13.6rem;
    `}
    ${props =>
		props.icon === "seat" &&
		`
		background-position: 0 -16.2rem;
    `}
    ${props =>
		props.icon === "insurance" &&
		`
		background-position: -2.7rem -16.2rem;
    `}
    ${props =>
		props.icon === "charge" &&
		`
		background-position: -5.4rem -16.2rem;
    `}
    ${props =>
		props.icon === "free" &&
		`
		background-position: -8rem -16.2rem;
    `}
    ${props =>
		props.icon === "shopping" &&
		`
		background-position: -10.7rem -16.2rem;
    `}
	${props =>
		props.icon === "green" &&
		`
		background-position: -16.4rem -13.6rem;
    `}
	${props =>
		props.icon === "caddy" &&
		`
		background-position: -13.2rem -16.2rem;
    `}
	${props =>
		props.icon === "bus" &&
		`
		background-position: -16.3rem -16.3rem;
    `}
	${props =>
		props.icon === "ship" &&
		`
		background-position: -8.06rem -11.4rem;
    `}
	${props =>
		props.icon === "train" &&
		`
		background-position: -5.4rem -11.4rem;
    `}
	${props =>
		props.icon === "transport-not" &&
		`
		background-position: -10.6rem -11.4rem;
    `}
`;

const AirlineWrap = styled.div`
	display: flex;
	gap: 3px;
	line-height: 1;
`;

const TopCategory = styled.ul`
	display: flex;
	gap: 15px;
	padding: 0 15px;
`;

const TopCategoryItem = styled.li<{$isActive?: boolean}>`
	padding: 14px 3px;
	font-size: var(--default-size);
	font-family: ${props => (props.$isActive ? "PT-medium" : "PT-regular")};
	color: ${props => (props.$isActive ? "var(--emp-color)" : "var(--gray-color)")};
	line-height: 1;
`;

export {
	Wrap,
	Header,
	Logo,
	ConfirmButton,
	LocalmainTitle,
	LocalList,
	ProductList,
	Thumbnail,
	InfoBox,
	Pirice,
	CategoryList,
	Category,
	CategoryListItem,
	FilterWrap,
	SelectBox,
	Price,
	ImageWrap,
	BtnBlock,
	OptionBox,
	ScheduleIconList,
	ScheduleIcon,
	AirlineWrap,
	TopCategory,
	TopCategoryItem,
};
